// Generated by scripts/generate-app-version.mjs.
export const APP_RELEASE = {
  "version": "1.0.0",
  "buildId": "20261104T191317151Z",
  "builtAt": "2026-11-04T19:13:17.151Z"
} as const;
